import { Row, Col } from "react-bootstrap";
import "../style/LucrareItem.css";
import { downloadDomeniuDocument } from "../backend/FileUploadService";
import { convertDateToFullYear } from "../utils/Utils";

const DocumentDomeniuItem = ({
  documentData,
  folderName,
  locationType,
  setDocumentToDelete,
}) => {
  const downloadDocument = async () => {
    const response = await downloadDomeniuDocument(
      locationType.toLowerCase(),
      folderName,
      documentData.fileName,
    );
    // Create a URL for the blob data received
    const documentUrl = window.URL.createObjectURL(new Blob([response]));

    // Create a temporary link element
    const link = document.createElement("a");
    link.href = documentUrl;
    link.setAttribute("download", documentData.originalFileName); // Set filename for the download
    document.body.appendChild(link);

    // Trigger the download
    link.click();

    // Cleanup: remove the temporary link element
    document.body.removeChild(link);
  };

  return (
    <Row className={"mb-1"}>
      <Row className="row_folder">
        <Col
          onClick={() => {
            downloadDocument();
          }}
          className="lucrare_folder_data"
          style={{ background: "#87cefa" }}
          md={8}
          onContextMenu={(e) => {
            e.preventDefault();
            setDocumentToDelete(documentData.fileName);
          }}
        >
          {documentData?.originalFileName || ""}
        </Col>
        <Col
          className="informatii_user_fisier"
          style={{ background: "#ffe7b3" }}
          md={4}
        >
          <Row>
            {documentData?.date
              ? convertDateToFullYear(documentData?.date)
              : ""}{" "}
            {documentData?.username?.toUpperCase() || ""}
          </Row>
        </Col>
      </Row>
    </Row>
  );
};
export default DocumentDomeniuItem;
